import React from 'react';
import { Col } from 'react-bootstrap';

class Footer extends React.Component {
    render() {
        return (
            <Col sm={12} className="footer">
                <hr />
                Vytvořil Lukáš Linhart
            </Col>
    )}
}

export default Footer;